'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Drawer as DrawerSparky, Icon, Logo, TextLink } from '@petsmart-ui/sparky';
import type { Entry } from 'contentful';
import { useState } from 'react';
import { LegacyIcon, LegacyIconName, useAuthSignInClick, useCart, useIsMounted, useLogout, useUserSession } from '@libs/common-next';
import { ComponentResolver, LegacyDrawerMenuItem, LegacyMinicart, useCategoryStack } from '@libs/contentful';
import { NAVIGATION_URLS } from '@libs/core';
import type { LegacyHeaderDrawerProps } from './types';
import './LegacyHeaderDrawer.scss';
export default function LegacyHeaderDrawer(t0) {
  const $ = _c(33);
  const {
    mainMenu,
    secondaryNavigation
  } = t0;
  const [isActive, setIsActive] = useState(false);
  const {
    user
  } = useUserSession();
  const {
    isAuth0Enabled,
    handleSignInClick
  } = useAuthSignInClick();
  const {
    isMounted
  } = useIsMounted();
  const {
    clearCart
  } = useCart();
  const logout = useLogout();
  const {
    currentCategories,
    categoryStack,
    handleCategoryClick,
    handleBackClick
  } = useCategoryStack(mainMenu?.fields?.category as Entry[]);
  const isLoggedIn = isMounted && !!user;
  const t1 = isActive ? "Close" : "Menu";
  const t2 = isActive ? "x" : "menu";
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setIsActive(true);
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== t1 || $[2] !== t2) {
    t4 = <Button data-testid="menu-button" variant="bare" text={t1} iconPosition="before" iconName={t2} size="lg" onClick={t3} className="header-drawer__button" hideText={true} />;
    $[1] = t1;
    $[2] = t2;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setIsActive(false);
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== handleSignInClick || $[6] !== isAuth0Enabled || $[7] !== isLoggedIn) {
    t6 = <div className="header-drawer__account">{isLoggedIn || !isAuth0Enabled ? <a href={NAVIGATION_URLS.legacy.account.base} title="Rewards & Account"><LegacyIcon aria-hidden="true" name={LegacyIconName.PERSON} size={20} /></a> : <button type="button" className="header-drawer__account-action" title="Rewards & Account" onClick={handleSignInClick}><LegacyIcon aria-hidden="true" name={LegacyIconName.PERSON} size={20} /></button>}</div>;
    $[5] = handleSignInClick;
    $[6] = isAuth0Enabled;
    $[7] = isLoggedIn;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Logo />;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="header-drawer__cart"><a href={NAVIGATION_URLS.legacy.storeLocator.base} title="Locate Stores"><LegacyIcon aria-hidden="true" name={LegacyIconName.PIN} size={24} /></a><LegacyMinicart /></div>;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t6) {
    t9 = <DrawerSparky.Header titleAfter={true}>{t6}{t7}{t8}</DrawerSparky.Header>;
    $[11] = t6;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== categoryStack || $[14] !== clearCart || $[15] !== currentCategories || $[16] !== handleBackClick || $[17] !== handleCategoryClick || $[18] !== handleSignInClick || $[19] !== isAuth0Enabled || $[20] !== isLoggedIn || $[21] !== logout || $[22] !== secondaryNavigation || $[23] !== user?.gn) {
    t10 = currentCategories?.categories && <DrawerSparky.Body className="drawer-body">{categoryStack.length > 1 ? <div className="header-drawer header-drawer--top"><button data-testid="back-button" onClick={handleBackClick} className="category__button--back category__button" type="button"><Icon size="lg" name="chevron-left" /><span>{currentCategories.displayText}</span></button></div> : null}<ul data-testid="drawer-body" className={`menu-category menu-category--lvl${categoryStack.length}`}>{currentCategories.categories.filter(_temp).map(category_0 => <LegacyDrawerMenuItem key={category_0.sysId} categoryStack={categoryStack} category={category_0} handleCategoryClick={handleCategoryClick} closeMenu={() => setIsActive(false)} />)}</ul><ComponentResolver className={`bottom-nav-links bottom-nav-links--lvl${categoryStack.length}`} entry={secondaryNavigation} isHeader={false} /><ul className={`mobile-top-menu hidden-lg bottom-nav-links bottom-nav-links--lvl${categoryStack.length}`}><li className="bottom-login-link">{isLoggedIn ? <p data-testid="logout" className="logout-anchor">{`Not ${user?.gn}?`}<TextLink onClick={async () => {
              await logout({
                redirectUrl: "/sign-in",
                callback: clearCart,
                forceRedirect: true
              });
            }} className="logout-btn">Sign Out</TextLink></p> : <>{isAuth0Enabled ? <button type="button" data-testid="login" className="login-anchor login-anchor--action" onClick={handleSignInClick}>Create Account<span className="login-btn">Sign In</span></button> : <a data-testid="login" href={NAVIGATION_URLS.legacy.account.base} className="login-anchor">Create Account<span className="login-btn">Sign In</span></a>}</>}</li></ul></DrawerSparky.Body>;
    $[13] = categoryStack;
    $[14] = clearCart;
    $[15] = currentCategories;
    $[16] = handleBackClick;
    $[17] = handleCategoryClick;
    $[18] = handleSignInClick;
    $[19] = isAuth0Enabled;
    $[20] = isLoggedIn;
    $[21] = logout;
    $[22] = secondaryNavigation;
    $[23] = user?.gn;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <DrawerSparky.Footer className="mobile-nav-footer"><a className="customer-care-number-wrapper" href="tel:18888399638"><span className="circled-phone"><Icon name="contact-outline" /></span><span className="customer-care-number">1-888-839-9638</span></a></DrawerSparky.Footer>;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== isActive || $[27] !== t10 || $[28] !== t9) {
    t12 = <DrawerSparky showBackdrop={false} className="legacy-drawer" isActive={isActive} onClose={t5} data-testid="legacy-header-drawer">{t9}{t10}{t11}</DrawerSparky>;
    $[26] = isActive;
    $[27] = t10;
    $[28] = t9;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t12 || $[31] !== t4) {
    t13 = <>{t4}{t12}</>;
    $[30] = t12;
    $[31] = t4;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  return t13;
}
function _temp(category, index, self) {
  return index === self.findIndex(c => c.sysId === category.sysId);
}